export default "__VITE_ASSET__Clt_S_oE__"